import React from 'react';

const OrderSuccess: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
    <path d="M9.63258 23.625C9.61988 23.625 9.60718 23.6248 9.59428 23.6246C8.82946 23.6127 8.11583 23.2385 7.67222 22.6173L1.90275 14.5354C1.13254 13.4564 1.38562 11.9594 2.46819 11.1917C3.55095 10.4237 5.05288 10.6761 5.82329 11.7551L9.71457 17.2062C11.22 15.2972 13.2331 12.8079 14.5027 11.4927C18.1621 7.70228 22.6634 4.86233 22.8532 4.7434C23.9777 4.03864 25.4631 4.3751 26.1706 5.49611C26.8781 6.61694 26.5401 8.09744 25.4154 8.80258C25.3748 8.8279 21.211 11.4605 17.9698 14.8178C15.9696 16.8897 11.5912 22.6212 11.5473 22.6787C11.092 23.2755 10.3834 23.625 9.63258 23.625Z" fill="#12B76A" />
  </svg>
);

export default OrderSuccess;
